import { render, staticRenderFns } from "./CreateEditUnidadeModal.vue?vue&type=template&id=bd3e80be&"
import script from "./CreateEditUnidadeModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditUnidadeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports